@let isErrorOccurred = errorNotificationService.isErrorOccurred$ | async;

<mm-navigation [activeNavigation]="'study-progress'"></mm-navigation>
<div class="micromate-learn-component"
     [class.micromate-learn-component-dev-error]="isErrorOccurred !== null && isErrorOccurred !== undefined && isErrorOccurred === true">
    <div class="micromate-learn-context">
        <mm-study-progress
            [changDetectionAfterTurn]="false"
            [darkMode]="false"
            [studyProgressesData]="studyProgresses$"
            (learnPackageActivated)="learnPackage($event)">
        </mm-study-progress>
    </div>
</div>

